// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6LGYI","rightAdornment":"Header_rightAdornment__1_e7Z"};